import { apiSlice } from './apiSlice';

export const fiscalPeriodsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFiscalPeriods: builder.query<any, Record<string, any> | void>({
      query: (params) => ({
        url: '/fiscal-periods',
        params: params || {},
      }),
      providesTags: ['FiscalPeriod'],
    }),
    getAllFiscalPeriods: builder.query<any, Record<string, any> | void>({
      query: (params) => ({
        url: '/fiscal-periods',
        params: params || {},
      }),
      providesTags: ['FiscalPeriod'],
    }),
    getCurrentFiscalPeriod: builder.query<any, void>({
      query: () => ({ url: '/fiscal-periods/current' }),
      providesTags: ['FiscalPeriod'],
    }),
    getValidationChecklist: builder.query<any, number | string>({
      query: (id) => ({ url: `/fiscal-periods/${id}/validation-checklist` }),
    }),
    getClosingChecklist: builder.query<any, number | string>({
      query: (id) => ({ url: `/fiscal-periods/${id}/closing-checklist` }),
      providesTags: ['FiscalPeriod'],
    }),
    runPeriodValidations: builder.mutation<any, number | string>({
      // Backend computes the checklist on demand via GET (no POST validate route).
      query: (id) => ({
        url: `/fiscal-periods/${id}/validation-checklist`,
        method: 'GET',
      }),
    }),
    closePeriod: builder.mutation<any, number | string>({
      query: (id) => ({
        url: `/fiscal-periods/${id}/close`,
        method: 'POST',
      }),
      invalidatesTags: ['FiscalPeriod'],
    }),
    previewCarryForward: builder.mutation<any, { id: number | string; data?: any }>({
      query: ({ id, data }) => ({
        // Backend route is GET (the old POST always returned 405).
        url: `/fiscal-periods/${id}/preview-carry-forward`,
        method: 'GET',
        params: data,
      }),
    }),
    carryForward: builder.mutation<any, { id: number | string; data?: any }>({
      query: ({ id, data }) => ({
        url: `/fiscal-periods/${id}/carry-forward`,
        method: 'POST',
        data: data,
      }),
      invalidatesTags: ['FiscalPeriod'],
    }),
    verifyCarryForward: builder.mutation<any, { closed_period_id: number | string; new_period_id: number | string }>({
      query: (data) => ({
        url: '/fiscal-periods/verify-carry-forward',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['FiscalPeriod'],
    }),
  }),
});

export const {
  useGetFiscalPeriodsQuery,
  useGetAllFiscalPeriodsQuery,
  useGetCurrentFiscalPeriodQuery,
  useGetValidationChecklistQuery,
  useLazyGetValidationChecklistQuery,
  useGetClosingChecklistQuery,
  useRunPeriodValidationsMutation,
  useClosePeriodMutation,
  usePreviewCarryForwardMutation,
  useCarryForwardMutation,
  useVerifyCarryForwardMutation,
} = fiscalPeriodsApi;
